import { CheckCircle2, CircleDashed } from "lucide-react";

const TABS = [
  {
    key: "unsolved",
    label: "Unsolved",
    Icon: CircleDashed,
    activeClasses: "bg-blue-500/20 shadow-[0_0_15px_rgba(59,130,246,0.25)] text-blue-400",
    countActiveClasses: "bg-blue-500/20 text-blue-300",
  },
  {
    key: "solved",
    label: "Solved",
    Icon: CheckCircle2,
    activeClasses: "bg-green-500/20 shadow-[0_0_15px_rgba(34,197,94,0.25)] text-green-400",
    countActiveClasses: "bg-green-500/20 text-green-300",
  },
];

function StatusTabs({ active, setActive, unsolvedTotal, solvedTotal }) {
  const counts = { unsolved: unsolvedTotal, solved: solvedTotal };

  return (
    <div
      role="tablist"
      aria-label="Problem status"
      className="flex w-full sm:w-auto p-1 rounded-xl bg-white/5 backdrop-blur-xl border border-white/10"
    >
      {TABS.map(({ key, label, Icon, activeClasses, countActiveClasses }) => {
        const isActive = active === key;

        return (
          <button
            key={key}
            role="tab"
            aria-selected={isActive}
            onClick={() => setActive(key)}
            className={`flex flex-1 sm:flex-none items-center justify-center gap-2 rounded-lg px-5 py-1.5 text-sm transition-all duration-200
              ${isActive ? activeClasses : "text-gray-400 hover:bg-white/5 hover:text-white"}`}
          >
            <Icon size={14} className={isActive ? "" : "text-gray-500"} />
            {label}
            <span
              className={`rounded-full px-1.5 py-0.5 text-xs font-medium tabular-nums
                ${isActive ? countActiveClasses : "bg-white/10 text-gray-400"}`}
            >
              {counts[key]}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export default StatusTabs;
